const MoveMemory = () => import('@/views/movememory/MoveMemory.vue');

export default [
  {
    path: '/movememory',
    name: 'MoveMemory',
    component: MoveMemory,
  }
];
